import React from 'react'
import { Table } from '@advanced/component-mosaic-table'
import { dataSources } from '../../utils/data-sources'
import { schema } from './schema'
import Router from 'next/router'
import { AuditStore } from '../../stores/audit'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import Http from '../../services/http'
import { SessionStore } from '../../stores'
import { PlaceholderCard } from '../../components/placeholder'
import { publish } from '../../utils/pubsub'

const margin = {
  marginTop: '36px'
}

@inject('auditStore', 'sessionStore')
@observer
class SubmittedReturns extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ready: false,
      startDate: '',
      endDate: '',
      filter: 'all',
      viewData: null,
      filterData: null,
      filteredData: null
    }
    this.table = null
    this.tableRef = React.createRef()
    this.http = Http.getInstance(this.props.sessionStore)
    this.dataSources = dataSources()
    this.handleSubmittedReturnRef = React.createRef()
    this.handleRadioFilterRef = React.createRef()
    this.handleChange = this.handleChange.bind(this)
    this.filterData = this.filterData.bind(this)
    this.clearFilter = this.clearFilter.bind(this)
  }

  handleChange (e) {
    if (e.target.value === 'all') {
      const data2 = this.state.viewData
      this.table.setData(data2.length, data2)
    }
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  filterData () {
    const startDate = document.getElementById('startDate').value
    const endDate = document.getElementById('endDate').value
    if (startDate.length > 0 && endDate.length > 0) {
      this.setState({
        startDate,
        endDate
      }, () => {
        if (this.state.startDate && this.state.endDate) {
          const newData = [...this.state.viewData]
          const startDate = new Date(this.state.startDate)
          const endDate = new Date(this.state.endDate).setHours(23, 59, 59)
          if (startDate > endDate) {
            publish('toastr.danger', 'To date should be greater than from date')
            return
          }
          const viewData = newData.filter(function (item) {
            const date = new Date(item.submittedOn)
            return (date >= startDate && date <= endDate)
          })
          this.setState({
            filterData: viewData
          }, () => {
            const data2 = this.state.filterData
            this.table.setData(data2.length, data2)
          })
        }
      })
    } else {
      publish('toastr.danger', 'Please select dates to filter')
    }
  }

  clearFilter () {
    document.getElementById('startDate').value = ''
    document.getElementById('endDate').value = ''
    this.setState({
      filteredData: null
    }, () => {
      this.intialiseTable()
    })
  }

  getTable () {
    return <div ref={this.tableRef} />
  }

  handleSubmit () {
    console.log(this.state.startDate)
  }

  loadData () {
    return this.http.getData(this.dataSources.submittedTaxReturn)
  }

  onTableAction (table, action, rowDetails) {
    if (action === 'registrationNumber') {
      this.props.auditStore.setReturnDetail({
        data: rowDetails[0].rowData
      })
      if (this.props.isReconciliation) {
        Router.push(`/reconciliation/summary?reconciliation=${rowDetails[0].rowData.ReconciliationId}&registration=${rowDetails[0].rowData.registrationNumber}
         &status=submitted&taxregistration=${rowDetails[0].rowData.TaxRegistrationId}&registeredName=${this.state.viewData[0].registeredName}`)
      } else {
        Router.push(`/audit/summary?taxreturn=${rowDetails[0].rowData.id}&taxregistration=${rowDetails[0].rowData.TaxRegistrationId}`)
      }
    }
  }

  renderData () {
    return this.state.filteredData ? this.state.filteredData : this.state.viewData
  }

  intialiseTable () {
    if (this.props.sessionStore.isBaseEdition) {
      delete schema.properties['approvedOn']
      delete schema.properties['approvedBy']
    }
    const data = () => this.renderData()
    const onAction = (table, action, [{ index, rowData, value }]) => this.onTableAction(table, action, [{ index, rowData, value }])
    this.table = new Table(this.tableRef.current, {
      bordered: true,
      small: true,
      headClassName: 'bg-light',
      schema,
      data,
      totalCount: this.state.viewData.length,
      onAction
    })
  }

  componentDidMount () {
    this.loadData()
      .then(viewData => {
        const nvd = { ...viewData }
        nvd.data.map(d => {
          if (d.submittedOn.toLowerCase() === 'n/a') {
            d.submittedOn = null
          }
          if (d.approvedOn.toLowerCase() === 'n/a') {
            d.approvedOn = null
          }
          return d
        })
        return Promise.resolve(nvd)
      })
      .then((viewData) => {
        if (viewData.status === 'success') {
          if (this.props.isReconciliation) {
            viewData.data = viewData.data.filter((item) => item.ReconciliationId)
          }
          viewData.data = viewData.data.sort((a, b) => new Date(b.submittedOn) - new Date(a.submittedOn))
          this.setState({
            ready: true,
            viewData: viewData.data
          }, () => {
            this.setup()
            if (viewData.data.length > 0) {
              this.intialiseTable()
            }
          })
        } else {
          const viewData = []
          this.setState({
            viewData,
            ready: true
          }, () => {
            this.setup()
          })
        }
      }).catch((e) => {
        console.error(e)
        const viewData = []
        this.setState({
          viewData,
          ready: true
        })
      })
  }

  setup = () => {
    if (this.handleSubmittedReturnRef.current) {
      this.handleSubmittedReturnRef.current.addEventListener('submit', (e) => this.handleSubmit(e))
    }
    if (this.handleRadioFilterRef.current) {
      this.handleRadioFilterRef.current.value = this.state.filter
      this.handleRadioFilterRef.current.addEventListener('change', (e) => { this.handleChange(e) })
    }
  }

  getDateRange () {
    if (this.state.filter !== 'all') {
      return (
        <mosaic-row>
          <mosaic-col lg='12' xl='8'>
            <mosaic-flex>
              <mosaic-datetime-picker
                class='col-lg-4 col-md-4 pt-lg-1'
                name='startDate'
                label='From date'
                date
                id='startDate'>
              </mosaic-datetime-picker>
              <mosaic-datetime-picker
                class='col-lg-4 col-md-4 pt-lg-1'
                name='endDate'
                label='To date'
                date
                id='endDate'>
              </mosaic-datetime-picker>
              <div style={margin}>
                <mosaic-button icon='delete_sign' class='mr-1' onClick={this.clearFilter} icon-only></mosaic-button>
                <mosaic-button icon='filter' onClick={this.filterData} icon-only></mosaic-button>
              </div>

            </mosaic-flex>
          </mosaic-col>
        </mosaic-row>
      )
    }
  }

  render () {
    if (this.state.ready) {
      if (this.state.viewData.length > 0) {
        return (
          <div>
            <mosaic-form ref={this.handleSubmittedReturnRef}>
              <fieldset>
                <legend />
                <mosaic-radio-group
                  block
                  name ='filter'
                  ref={this.handleRadioFilterRef}
                  value={this.state.filter}
                >
                  <mosaic-radio
                    color='primary'
                    id='all'
                    label='All'
                    value='all'
                  />
                  <mosaic-radio
                    color='primary'
                    id='dateRange'
                    label='Date range'
                    value='dateRange'
                  />

                </mosaic-radio-group>
              </fieldset>

              {this.getDateRange()}
            </mosaic-form>
            <p className='mb-2'> </p>
            {this.getTable()}

          </div>
        )
      } else {
        return (<p className='mb-4 p-lg-0'>There are no results related to your search.</p>)
      }
    } else {
      return (<PlaceholderCard />)
    }
  }
}

SubmittedReturns.defaultProps = {
  isAudit: false,
  isReconciliation: false
}

SubmittedReturns.propTypes = {
  auditStore: PropTypes.instanceOf(AuditStore),
  sessionStore: PropTypes.instanceOf(SessionStore),
  isAudit: PropTypes.bool,
  isReconciliation: PropTypes.bool
}

export { SubmittedReturns }
